import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../Styles/Feecategory.css";
import ApiConfig from "../api/ApiConfig";
import { simplePostCall } from "../api/ApiServices";
import ScaleLoader from "react-spinners/ScaleLoader";
import { toast, ToastContainer } from "react-toastify";

export default function FeeCategoryTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]); // Original API data
  const [filteredData, setFilteredData] = useState([]); // Data shown in table

  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("All");

  const handleNavigate = (path) => navigate(`/${path}`);

  useEffect(() => {
    loadDataStudentFee();
  }, []);

  // Sync filteredData whenever search, dropdown, or raw data changes
  useEffect(() => {
    let result = data;

    // Filter by Type (Fee, Discount, etc.)
    if (selectedType !== "All") {
      result = result.filter(
        (item) =>
          item.fee_category_type?.toLowerCase() === selectedType.toLowerCase(),
      );
    }

    // Filter by Search Term (Category Name)
    if (searchTerm) {
      result = result.filter((item) =>
        item.fee_category_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()),
      );
    }

    setFilteredData(result);
  }, [searchTerm, selectedType, data]);

  const loadDataStudentFee = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      category_name: "", // Fetching all and filtering client-side for speed
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeCategorylist,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        setData(response.data);
        setFilteredData(response.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error loading list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    setSelectedType("All");
  };

  const loadDataStudentFeeDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    try {
      const response = await simplePostCall(
        ApiConfig.feeCategoryDELETE,
        JSON.stringify({
          customer_id: Number(customer_id),
          api_key: api_key,
          category_id: id,
        }),
      );

      if (response?.result) {
        toast.success("Deleted Successfully!");
        loadDataStudentFee(); // Refresh the list
      } else {
        toast.error(response?.message || "Delete failed");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="category-container my-4">
      <ToastContainer />
      {/* Header */}
      <div className="special-header d-flex justify-content-between">
        <h4 className="page-title pt-1" style={{ marginTop: "6px" }}>
          Fee Categories
        </h4>
        <Link
          to="/createfee"
          className="btn custom-btn pt-2"
          style={{ height: "40px", marginTop: "3px", minWidth: "205px" }}
        >
          <span style={{ fontSize: "13px" }}>Create Fee Category</span>
        </Link>
      </div>

      {/* Filters Section */}
      <div
        className="table-top-filters d-flex flex-wrap gap-3"
        style={{ marginTop: "15px" }}
      >
        <div
          className="input-container"
          style={{ position: "relative", maxWidth: "200px" }}
        >
          <i
            className="bi bi-search"
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#888",
            }}
          ></i>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search Category"
            style={{ paddingLeft: "30px", height: "40px" }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select
          className="form-select form-select-sm"
          style={{ maxWidth: "200px" }}
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <option value="All">All Types</option>
          <option value="Fee">Fee</option>
          <option value="Discount">Discount</option>
          <option value="Bonus">Bonus</option>
        </select>

        <button
          type="button"
          className="btn custom-btn btn-sm"
          onClick={handleClear}
        >
          Clear
        </button>
      </div>

      {/* Table */}
      <div className="card shadow-sm mt-3">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="custom-table w-100">
              <thead>
                <tr>
                  <th className="text-center">Sr No</th>
                  <th className="text-center">Category Name</th>
                  <th className="text-center">Category Type</th>
                  <th className="text-center">Amount Type</th>
                  <th className="text-center">Applicable To</th>
                  <th className="text-center">Category Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="7">
                      <div className="d-flex justify-content-center align-items-center py-1">
                        <ScaleLoader color="#F4BB44" />
                      </div>
                    </td>
                  </tr>
                ) : filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <tr key={row.fee_category_id || index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{row.fee_category_name}</td>
                      <td className="text-center">{row.fee_category_type}</td>
                      <td className="text-center">
                        {row.fee_category_amount_type}
                      </td>
                      <td className="text-center">
                        {row.fee_category_applicable_to}
                      </td>
                      <td className="text-center">{row.fee_category_status}</td>
                      <td className="text-center">
                        <div className="btn-group">
                          <button
                            className="btn btn-sm"
                            onClick={() =>
                              handleNavigate(
                                `Registration/${row.fee_category_id}`,
                              )
                            }
                          >
                            <i className="bi bi-eye"></i>
                          </button>
                          <button
                            className="btn btn-sm"
                            onClick={() =>
                              handleNavigate(`createfee/${row.fee_category_id}`)
                            }
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            className="btn btn-sm text-danger"
                            onClick={() =>
                              loadDataStudentFeeDelete(row.fee_category_id)
                            }
                          >
                            <i className="bi bi-trash3"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center p-3">
                      No Categories Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
